import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface CreateVisitResponse {
  visitId: string;
}

interface TranscriptResponse {
  visitId: string;
  transcript: string;
}

interface SummaryResponse {
  visitId: string;
  summary: string;
}

interface TreatmentCode {
  code: string;
  description: string;
  reason: string;
}

interface CodingResponse {
  visitId: string;
  codes: TreatmentCode[];
}

export const dentistApi = createApi({
  reducerPath: "dentistApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000' }),
  endpoints: (builder) => ({
    createVisit: builder.mutation<CreateVisitResponse, void>({
      query: () => ({
        url: "/api/v1/visits",
        method: "POST",
      }),
    }),

    getTranscript: builder.query<TranscriptResponse, string>({
      query: (visitId) => `/api/v1/visits/${visitId}/transcript`,
    }),

    generateSummary: builder.mutation<SummaryResponse, { visitId: string; lang?: string }>({
      query: ({ visitId, lang = "en" }) => ({
        url: `/api/v1/visits/${visitId}/summary`,
        method: "POST",
        params: { lang },
      }),
    }),

    generateCoding: builder.mutation<CodingResponse, { visitId: string; lang?: string }>({
      query: ({ visitId, lang = "en" }) => ({
        url: `/api/v1/visits/${visitId}/coding`,
        method: "POST",
        params: { lang },
      }),
    }),
  }),
});

export const {
  useCreateVisitMutation,
  useGetTranscriptQuery,
  useLazyGetTranscriptQuery,
  useGenerateSummaryMutation,
  useGenerateCodingMutation,
} = dentistApi;
